import { useState, useEffect } from 'react';

/**
 * Returns true if Loyalty Program feature is enabled.
 * Defaults to true if no setting has been explicitly saved.
 */
export const isLoyaltyEnabled = () => {
    try {
        const cached = localStorage.getItem('enable_loyalty_program');
        return cached === 'true' || cached === '1';
    } catch (e) {
        return false;
    }
};

/**
 * Hook providing reactive access to the Loyalty Program enabled state.
 * Listens for local updates and cross-tab storage changes.
 */
export const useLoyaltySetting = () => {
    const [enableLoyalty, setEnableLoyalty] = useState(isLoyaltyEnabled);

    useEffect(() => {
        const handleStorageChange = () => {
            setEnableLoyalty(isLoyaltyEnabled());
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('loyalty_setting_changed', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('loyalty_setting_changed', handleStorageChange);
        };
    }, []);

    const updateLoyaltySetting = (enabled) => {
        const strVal = enabled ? 'true' : 'false';
        localStorage.setItem('enable_loyalty_program', strVal);
        setEnableLoyalty(enabled);
        window.dispatchEvent(new Event('loyalty_setting_changed'));
        window.dispatchEvent(new Event('storage'));
    };

    return { enableLoyalty, updateLoyaltySetting };
};

export default useLoyaltySetting;
